/**
 * @generated SignedSource<<a5ce32eeb595ec8bed9e52947c64da9e>>
 * @relayHash 9ac6ab21aa57f6416355dc55971508f3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 9ac6ab21aa57f6416355dc55971508f3

import { ConcreteRequest } from 'relay-runtime';
export type dePreparationByNameQuery$variables = {
  pharmaceuticalCentralNumber: string;
  preparationName: string;
  skip: boolean;
};
export type dePreparationByNameQuery$data = {
  readonly de_preparationByProductName?: {
    readonly result?: {
      readonly composition: ReadonlyArray<string>;
      readonly distributionChannel: string;
      readonly isPrescriptionRequired: boolean;
      readonly name: string;
      readonly pharmaceuticalCentralNumberList: ReadonlyArray<{
        readonly name: string;
        readonly pharmaceuticalCentralNumber: string;
        readonly price: string;
        readonly quantity: string;
        readonly unit: string;
      }>;
      readonly pharmaceuticalForm: {
        readonly ifaCode: string;
        readonly name: string;
      };
      readonly productId: number;
    };
  };
};
export type dePreparationByNameQuery = {
  response: dePreparationByNameQuery$data;
  variables: dePreparationByNameQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pharmaceuticalCentralNumber"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "preparationName"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skip"
},
v3 = [
  {
    "kind": "Variable",
    "name": "pharmaceuticalCentralNumber",
    "variableName": "pharmaceuticalCentralNumber"
  },
  {
    "kind": "Variable",
    "name": "preparationName",
    "variableName": "preparationName"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PreparationResponse",
      "kind": "LinkedField",
      "name": "result",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "composition",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "distributionChannel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isPrescriptionRequired",
          "storageKey": null
        },
        (v4/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "PharmaceuticalFormResponse",
          "kind": "LinkedField",
          "name": "pharmaceuticalForm",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "ifaCode",
              "storageKey": null
            },
            (v4/*:: as any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "PharmaceuticalCentralNumberResponse",
          "kind": "LinkedField",
          "name": "pharmaceuticalCentralNumberList",
          "plural": true,
          "selections": [
            (v4/*:: as any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "pharmaceuticalCentralNumber",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "price",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "quantity",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "unit",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "de_SuccessPreparationDetailResult",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "dePreparationByNameQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "de_preparationByProductName",
            "plural": false,
            "selections": [
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/),
      (v2/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "dePreparationByNameQuery",
    "selections": [
      {
        "condition": "skip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "alias": null,
            "args": (v3/*:: as any*/),
            "concreteType": null,
            "kind": "LinkedField",
            "name": "de_preparationByProductName",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v5/*:: as any*/)
            ],
            "storageKey": null
          }
        ]
      }
    ]
  },
  "params": {
    "id": "9ac6ab21aa57f6416355dc55971508f3",
    "metadata": {},
    "name": "dePreparationByNameQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "a58251e05cca0022f1ac229553ec513f";

export default node;
